var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzAccessModelsLinkOnlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz access models link-only icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29l-3 3a7 7 0 0 1-10-10l7-7a7 7 0 0 1 10 0M28 19l3-3a7 7 0 0 1 10 10l-7 7a7 7 0 0 1-10 0M17 31l14-14",
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzAccessModelsLinkOnlyIcon);
export default __webpack_public_path__ + "static/media/talentlenz-access-models-link-only-icon.37dc1aa25c5a205742f2694026cc9ca6.svg";
export { ForwardRef as ReactComponent };